import { Stack } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import { MUIExternalLink } from 'components/common/MUIExternalLink'
import { TruncatedTextWithTooltip } from 'components/common/TruncatedTextWithTooltip'
import Icon from 'components/Icon'
import {
  getLogo,
  getPresetKeyFromURL
} from 'components/scenarios/create/status-checks/third-party-presets'
import { useGetStatusChecksUrls } from 'components/status-checks/hooks/use-get-status-checks-urls'
import {
  getMonitorPageUrl,
  isCustomStatusCheck
} from 'components/status-checks/status-checks-form-utils'
import { muiTheme } from 'mui-theme'
import theme from 'theme'
import { type StatusCheck } from 'types/api/status-checks/status-check'
import { getIntegrationTypeFromObservabilityToolTypeAndDomain } from 'utils/team-external-integrations/team-external-integrations-util'

export const StatusCheckListNameCell: React.FC<{
  statusCheck: StatusCheck
}> = ({ statusCheck }) => {
  const integrationType = getIntegrationTypeFromObservabilityToolTypeAndDomain(
    statusCheck.teamExternalIntegration.observabilityToolType,
    statusCheck.teamExternalIntegration.domain
  )

  const statusChecksUrls = useGetStatusChecksUrls()

  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', columnGap: 2, maxWidth: '100%' }}
    >
      <Link to={statusChecksUrls.edit(statusCheck.identifier)}>
        {isCustomStatusCheck(statusCheck) ? (
          <Icon
            css={{
              color: 'initial',
              width: muiTheme.spacing(4),
              height: muiTheme.spacing(4)
            }}
            icon="wavePulse"
          />
        ) : (
          <img
            css={{
              color: theme.colors.gray[1],
              width: theme.fontSizes[5],
              height: theme.fontSizes[5]
            }}
            src={getLogo(
              getPresetKeyFromURL(statusCheck.endpointConfiguration?.url)
            )}
          />
        )}
      </Link>
      <Stack sx={{ maxWidth: `calc(100% - ${muiTheme.spacing(5)})` }}>
        <TruncatedTextWithTooltip
          data-test-status-check-list-row-name={statusCheck.name}
          tooltipProps={{
            title: statusCheck.name
          }}
        >
          <Link to={statusChecksUrls.edit(statusCheck.identifier)}>
            {statusCheck.name}
          </Link>
        </TruncatedTextWithTooltip>
        {statusCheck.endpointConfiguration?.url && (
          <Stack
            direction="row"
            sx={{
              alignItems: 'baseline',
              columnGap: 1
            }}
          >
            <TruncatedTextWithTooltip
              color={theme.colors.steel[1]}
              tooltipProps={{
                title: statusCheck.endpointConfiguration.url
              }}
              variant="caption"
            >
              {statusCheck.endpointConfiguration.url}
            </TruncatedTextWithTooltip>
            {statusCheck.rawEndpointConfiguration?.url && (
              <MUIExternalLink
                href={getMonitorPageUrl(
                  statusCheck.rawEndpointConfiguration.url,
                  integrationType
                )}
              >
                <Icon icon="arrowUpRightFromSquare" />
              </MUIExternalLink>
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}
